export const GET_ALL_CONTACT_PERSONS_REQUEST = 'GET_ALL_CONTACT_PERSONS_REQUEST';
export const GET_ALL_CONTACT_PERSONS_SUCCESS = 'GET_ALL_CONTACT_PERSONS_SUCCESS';
export const GET_ALL_CONTACT_PERSONS_FAILURE = 'GET_ALL_CONTACT_PERSONS_FAILURE';

export const GET_ACTIVE_CONTACT_PERSONS_REQUEST = 'GET_ACTIVE_CONTACT_PERSONS_REQUEST';
export const GET_ACTIVE_CONTACT_PERSONS_SUCCESS = 'GET_ACTIVE_CONTACT_PERSONS_SUCCESS';
export const GET_ACTIVE_CONTACT_PERSONS_FAILURE = 'GET_ACTIVE_CONTACT_PERSONS_FAILURE';

export const ADD_CONTACT_PERSON_REQUEST = 'ADD_CONTACT_PERSON_REQUEST';
export const ADD_CONTACT_PERSON_SUCCESS = 'ADD_CONTACT_PERSON_SUCCESS';
export const ADD_CONTACT_PERSON_FAILURE = 'ADD_CONTACT_PERSON_FAILURE';

export const UPDATE_CONTACT_PERSON_REQUEST = 'UPDATE_CONTACT_PERSON_REQUEST';
export const UPDATE_CONTACT_PERSON_SUCCESS = 'UPDATE_CONTACT_PERSON_SUCCESS';
export const UPDATE_CONTACT_PERSON_FAILURE = 'UPDATE_CONTACT_PERSON_FAILURE';

export const UPDATE_STATUS_REQUEST = 'UPDATE_STATUS_REQUEST';
export const UPDATE_STATUS_SUCCESS = 'UPDATE_STATUS_SUCCESS';
export const UPDATE_STATUS_FAILURE = 'UPDATE_STATUS_FAILURE';

export const SEARCH_CONTACT_PERSONS_REQUEST = 'SEARCH_CONTACT_PERSONS_REQUEST';
export const SEARCH_CONTACT_PERSONS_SUCCESS = 'SEARCH_CONTACT_PERSONS_SUCCESS';
export const SEARCH_CONTACT_PERSONS_FAILURE = 'SEARCH_CONTACT_PERSONS_FAILURE';

export const GET_CONTACT_PERSON_BY_ID_REQUEST = 'GET_CONTACT_PERSON_BY_ID_REQUEST';
export const GET_CONTACT_PERSON_BY_ID_SUCCESS = 'GET_CONTACT_PERSON_BY_ID_SUCCESS';
export const GET_CONTACT_PERSON_BY_ID_FAILURE = 'GET_CONTACT_PERSON_BY_ID_FAILURE';
